import { Injectable } from '@angular/core';
import { Observable ,  BehaviorSubject } from 'rxjs';


@Injectable()
export class AppNavigationService {

    // Set Local Storage Variable
    localStorage = window.localStorage;

    // Other Components can Inject the User Service and Subscribe to the Observable
    public isShowBackSubject$ = new BehaviorSubject<boolean>(false);

    // Other Components can Inject the User Service and Subscribe to the Observable
    private isShowMenuSubject = new BehaviorSubject<boolean>(true);
    // When Injecting the Service Components can subscribe to the isLoggedIn Observable
    // Then anytime in the App you Call the Auth.Service and 
    public isShowMenu$ = this.isShowMenuSubject.asObservable();        

    constructor(){
        // localStorage.setItem('showBackButton', 'false');
    }


    showBackButton()
    {
        this.isShowBackSubject$.next(true);
        localStorage.setItem('showBackButton', 'true');
    }

    hideBackButton()
    {
        this.isShowBackSubject$.next(false);
        localStorage.setItem('showBackButton', 'false');
    }

    // Show the Hamburger Menu Button
    showMenuButton()
    {
        this.isShowMenuSubject.next(true);
        localStorage.setItem('showMenuButton', 'true');
    }

    // Hide the Hamburger Menu Button
    hideMenuButton()
    {
        this.isShowMenuSubject.next(false);
        localStorage.setItem('showMenuButton', 'false');
    }    

}

